import * as THREE from "three";
import Camera from "./Camera";
import Renderer from "./Renderer";
import sources from "./sources";
import Debug from "./utils/Debug";
import Resources from "./utils/Resources";
import Sizes from "./utils/Sizes";
import Time from "./utils/Time";
import World from "./World/World";

let instance: Experience | null = null;

export default class Experience {
  canvas!: HTMLElement;
  sectionsRoot!: HTMLElement;
  sizes!: Sizes;
  debug!: Debug;
  time!: Time;
  scene!: THREE.Scene;
  camera!: Camera;
  renderer!: Renderer;
  resources!: Resources;
  world!: World;

  constructor(_canvas?: HTMLElement, _sectionsRoot?: HTMLElement) {
    // Singleton
    if (instance) {
      return instance;
    }
    instance = this;

    // Global access
    (window as any).experience = this;

    // Options
    this.canvas = _canvas!;
    this.sectionsRoot = _sectionsRoot!;

    // Setup
    this.debug = new Debug();
    this.sizes = new Sizes();
    this.time = new Time();
    this.scene = new THREE.Scene();
    this.resources = new Resources(sources);
    this.camera = new Camera();
    this.renderer = new Renderer();
    this.world = new World();

    // Resize event
    this.sizes.on("resize", () => {
      this.resize();
    });

    // Time tick event
    this.time.on("tick", () => {
      this.update();
    });
  }

  resize() {
    this.camera.resize();
    this.renderer.resize();
    this.world.resize();
  }

  update() {
    this.camera.update();
    this.world.update();
    this.renderer.update();
  }

  destroy() {
    this.sizes.off("resize");
    this.time.off("tick");

    // Traverse the whole scene
    this.scene.traverse((child) => {
      // Test if it's a mesh
      if (child instanceof THREE.Mesh) {
        child.geometry.dispose();

        // Loop through the material properties
        for (const key in child.material) {
          const value = child.material[key];

          // Test if there is a dispose function
          if (value && typeof value.dispose === "function") {
            value.dispose();
          }
        }
      }
    });

    this.camera.controls.dispose();
    this.renderer.instance.dispose();

    if (this.debug.ui) this.debug.ui.destroy();
  }
}
